// Module
var code = `<div id="edit-loan-amortization">
  <form name="\$ctrl.formAmortization">
    <div class="alert alert--danger"
         ng-if="\$ctrl.loan.principalAmount !== \$ctrl.totalPrincipalAmount">
      <p ng-if="!\$ctrl.allowUpdatePrincipalAmount">
        The principal amount sum should match the loan principal amount.<br />
        Expected amount: <strong>{{\$ctrl.loan.principalAmount | nxCurrency}}</strong><br />
        Actual amount: <strong>{{\$ctrl.totalPrincipalAmount | nxCurrency}}</strong>
      </p>

      <p ng-if="\$ctrl.allowUpdatePrincipalAmount">
        The principal amount will be updated.<br />
        Current amount: <strong>{{\$ctrl.loan.principalAmount | nxCurrency}}</strong><br />
        New amount: <strong>{{\$ctrl.totalPrincipalAmount | nxCurrency}}</strong>
      </p>
    </div>

    <div class="alert alert--danger"
         ng-if="\$ctrl.loan.principalBalance !== \$ctrl.totalPrincipalBalance && !\$ctrl.editPrincipal">
      <p>
        The principal balance sum should match the loan principal balance.<br />
        Expected balance: <strong>{{\$ctrl.loan.principalBalance | nxCurrency}}</strong><br />
        Actual balance: <strong>{{\$ctrl.totalPrincipalBalance | nxCurrency}}</strong>
      </p>
    </div>

    <div class="alert alert--danger"
         ng-if="\$ctrl.loan.principalBalance !== \$ctrl.totalPrincipalBalance && \$ctrl.editPrincipal">
      <p>
        The principal balance has been updated. GL balances will not be automatically updated by this change.<br />
        Old balance: <strong>{{\$ctrl.loan.principalBalance | nxCurrency}}</strong><br />
        Updated balance: <strong>{{\$ctrl.totalPrincipalBalance | nxCurrency}}</strong>
      </p>
    </div>

    <div class="alert" ng-if="\$ctrl.loan.asEarnedInterestCalculation">
      You're editing an 'as earned' loan. Upon saving, 'as earned' interest will be replaced with the interest provided
      on this screen.
    </div>

    <form-section>
      <div class="amortization-table-container">
        <table class="table table--wide table--tiny-inputs">
          <thead>
          <tr>
            <td class="fixed-col line-number">No</td>
            <td class="fixed-col due-date">Due Date</td>
            <td>Status</td>
            <td>Principal</td>
            <td>Interest</td>
            <td ng-if="\$ctrl.hasCbu()">CBU Charge Amount</td>
            <td ng-if="\$ctrl.hasPf()">PF</td>
            <td ng-if="\$ctrl.hasTp()">TP</td>
            <td>Custom Fees</td>
            <td>Penalty</td>
            <td>Penalty Maturity</td>
            <td>Past due interest</td>
            <td>Past due maturity interest</td>
            <td class="fixed-col total">Total</td>
          </tr>
          </thead>
          <tbody class="tbody">
          <tr
            ng-repeat-start="item in \$ctrl.loan.amortizationSchedule.list"
            ng-click="item.lineNumber && \$ctrl.amortizationClicked(item, \$event)">
            <td class="fixed-col line-number">
              {{\$index+1}}
            </td>
            <td class="fixed-col due-date">
              <date ng-model="item.dueDate"
                    ng-disabled="\$last && !\$ctrl.editPrincipal"
                    ng-required="true"></date>
            </td>
            <td>
              <select
                required
                ng-model="item.status"
                ng-options="status for status in \$ctrl.statusOptions">
              </select>
            </td>
            <td>
              <div class="input-cell">
                <cash min="0" max="item.principalAmount"
                      ng-model="item.principalBalance"
                      ng-change="\$ctrl.calculateBalance(item); \$ctrl.calculatePrincipalTotal()"
                      ng-disabled="!\$ctrl.editPrincipal"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of">/</span>
                <cash min="0"
                      ng-change="\$ctrl.calculateAmount(item); \$ctrl.calculatePrincipalTotal()"
                      ng-disabled="!\$ctrl.editPrincipal"
                      ng-model="item.principalAmount" ng-required="true" hide-currency="true"></cash>
              </div>
            </td>
            <td>
              <div class="input-cell">
                <cash min="0" max="item.interestAmount"
                      ng-if="!\$ctrl.loan.asEarnedInterestCalculation"
                      ng-model="item.interestBalance"
                      ng-change="\$ctrl.calculateBalance(item)"
                      ng-required="true"
                      hide-currency="true"></cash>
                <cash min="0"
                      ng-if="\$ctrl.loan.asEarnedInterestCalculation"
                      ng-model="item.interestBalance"
                      ng-change="\$ctrl.calculateBalance(item)"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of" ng-if="!\$ctrl.loan.asEarnedInterestCalculation">/</span>
                <cash min="0"
                      ng-if="!\$ctrl.loan.asEarnedInterestCalculation"
                      ng-change="\$ctrl.calculateAmount(item)"
                      ng-model="item.interestAmount"
                      ng-required="true"
                      hide-currency="true"></cash>
              </div>
            </td>
            <td ng-if="\$ctrl.hasCbu()">
              <div class="input-cell">
                <cash min="0" max="item.cbuChargeAmount"
                      ng-model="item.cbuChargeBalance"
                      ng-change="\$ctrl.calculateBalance(item)"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of">/</span>
                <cash min="0"
                      ng-change="\$ctrl.calculateAmount(item)"
                      ng-model="item.cbuChargeAmount"
                      ng-required="true"
                      hide-currency="true"></cash>
              </div>
            </td>
            <td ng-if="\$ctrl.hasPf()">
              <div class="input-cell">
                <cash min="0" max="item.pfChargeAmount"
                      ng-model="item.pfChargeBalance"
                      ng-change="\$ctrl.calculateBalance(item)"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of">/</span>
                <cash min="0"
                      ng-change="\$ctrl.calculateAmount(item)"
                      ng-model="item.pfChargeAmount"
                      ng-required="true"
                      hide-currency="true"></cash>
              </div>
            </td>
            <td ng-if="\$ctrl.hasTp()">
              <div class="input-cell">
                <cash min="0"
                      ng-model="item.tpChargeBalance"
                      ng-change="\$ctrl.calculateBalance(item)"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of">/</span>
                <cash min="0"
                      ng-change="\$ctrl.calculateAmount(item)"
                      ng-model="item.tpChargeAmount"
                      ng-required="true"
                      hide-currency="true"></cash>
              </div>
            </td>
            <td>
              <div class="input-cell">
                <cash min="0"
                      ng-disabled="true"
                      ng-model="item.customFeesBalance"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of">/</span>
                <cash min="0"
                      ng-disabled="true"
                      ng-model="item.customFeesAmount"
                      ng-required="true"
                      hide-currency="true"></cash>
              </div>
            </td>
            <td>
              <div class="input-cell">
                <cash min="0" max="item.penaltyAmount"
                      ng-model="item.penaltyBalance"
                      ng-change="\$ctrl.calculateBalance(item)"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of">/</span>
                <cash min="0"
                      ng-change="\$ctrl.calculateAmount(item)"
                      ng-model="item.penaltyAmount"
                      ng-required="true"
                      hide-currency="true"></cash>
              </div>
            </td>
            <td>
              <div class="input-cell">
                <cash min="0" max="item.penaltyMaturityAmount"
                      ng-model="item.penaltyMaturityBalance"
                      ng-change="\$ctrl.calculateBalance(item)"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of">/</span>
                <cash min="0"
                      ng-change="\$ctrl.calculateAmount(item)"
                      ng-model="item.penaltyMaturityAmount"
                      ng-required="true"
                      hide-currency="true"></cash>
              </div>
            </td>
            <td>
              <div class="input-cell">
                <cash min="0" max="item.pastDueInterestAmount"
                      ng-model="item.pastDueInterestBalance"
                      ng-change="\$ctrl.calculateBalance(item)"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of">/</span>
                <cash min="0"
                      ng-change="\$ctrl.calculateAmount(item)"
                      ng-model="item.pastDueInterestAmount"
                      ng-required="true"
                      hide-currency="true"></cash>
              </div>
            </td>
            <td>
              <div class="input-cell">
                <cash min="0" max="item.pastDueMaturityInterestAmount"
                      ng-model="item.pastDueMaturityInterestBalance"
                      ng-change="\$ctrl.calculateBalance(item)"
                      ng-required="true"
                      hide-currency="true"></cash>
                <span class="out-of">/</span>
                <cash min="0"
                      ng-change="\$ctrl.calculateAmount(item)"
                      ng-model="item.pastDueMaturityInterestAmount"
                      ng-required="true"
                      hide-currency="true"></cash>
              </div>
            </td>
            <!--Update on change-->
            <td class="fixed-col total">{{item.amortizationBalance | nxCurrency:'noSuffix'}} / {{item.amortizationAmount | nxCurrency}}</td>
          </tr>
          <tr ng-repeat-end class="table__row--not-hoverable">
            <td colspan="100%" class="custom-fee">
              <div class="toggleable-panel-wrapper amortization-custom-fees-wrapper"
                   ng-class="{'toggleable-panel-wrapper--toggled': item.lineNumber && item.lineNumber === \$ctrl.selectedAmortizationLineNumber}">
                <amortization-custom-fees-inline-panel
                  ng-if="\$ctrl.getCustomFees() && \$ctrl.loanPaymentFeeDefinitions"
                  amortization="item"
                  custom-fees="\$ctrl.getCustomFees()"
                  on-update="\$ctrl.recalculateAmortizations(); \$ctrl.calculatePrincipalTotal()"
                  on-hide="\$ctrl.hideCustomFeesDetails()"
                  fee-definitions="\$ctrl.loanPaymentFeeDefinitions"
                >
                </amortization-custom-fees-inline-panel>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </form-section>
  </form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/common/edit-loan-amortization.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;